import Logger from 'js-logger';
import * as c from 'utils/constants/constants';
import { Dispatch, AnyAction } from 'redux';
import { initialize } from 'utils/initUtils';
import { lsGet, LsKey, lsSet } from 'utils/localStorageUtils';
import { setWampConnectError, userLoggedOut } from 'redux/loginSlice';
import { setSnackbarMessage } from 'redux/snackBarSlice';

let dialog: any;

const onFailed = (result: any, dispatch: Dispatch<AnyAction>) => {
  switch (result.error.code) {
    case 12004:
      Logger.error('Domain is not trusted');
      break;
    case 12005:
      Logger.error('HTTPS is required');
      break;
    case 12007:
      Logger.error('A dialog is already opened.');
      break;
    case 12009:
      Logger.error('User has ignored the popup');
      dispatch(setSnackbarMessage(true));
      const popUpAlert = document.getElementById('popUpBlockedByUserAlert');
      popUpAlert && popUpAlert.scrollIntoView();
      break;
    default:
      Logger.log(JSON.stringify(result));
      Logger.error(result.error.message);
      break;
  }
};

const dialogMessageHandler = async (event: any, dispatch: Dispatch<AnyAction>) => {
  let dialogMessage = event.message || '';
  dialogMessage = JSON.parse(dialogMessage);
  switch (dialogMessage.action) {
    case c.LOGIN_SUCCESS:
      lsSet(LsKey.A_TOKEN, dialogMessage.payload);
      dispatch(setWampConnectError(false));
      setTimeout(async () => {
        await initialize(lsGet(LsKey.A_TOKEN) || '', (window as any).store);
      }, 100);
      break;
    case c.LOGOUT_SUCCESS:
      Logger.log('User Logged out');
      dispatch(userLoggedOut());
      break;
  }
  dialog.close();
};

/**
 * Open Dialog when user is loging in browser.
 * @param url
 * @param promptBeforeOpen
 * @param displayInIframe
 * @param store
 */
export const openDialog = (url: string, promptBeforeOpen = false, displayInIframe = false, dispatch: Dispatch<AnyAction>) => {
  Logger.info('Started Opening dialog for: ', url);
  const dialogOptions = {
    width: 60,
    height: 70,
    promptBeforeOpen,
    displayInIframe
  };
  Office.context.ui.displayDialogAsync(url, dialogOptions, (result) => {
    if (result.status.toString().toLowerCase() === 'failed') {
      Logger.info('Opening dialog failed for: ', url);
      onFailed(result, dispatch);
      return;
    }
    Logger.info('Success Opening dialog for: ', url);
    dialog = result.value;
    // Events are sent by the platform in response to user actions or errors. For example, the dialog is closed via the 'x' button
    dialog.addEventHandler(Office.EventType.DialogEventReceived, (event: any) => {
      Logger.debug('Dialog Closed: ', event);
      // dialog.close();
    });
    // Messages are sent by developers programmatically from the dialog using office.context.ui.messageParent(...)
    dialog.addEventHandler(Office.EventType.DialogMessageReceived, (event: any) => {
      return dialogMessageHandler(event, dispatch);
    });
  });
};
